module.exports = __webpack_public_path__ + "static/img/剪4.68e1625.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪4.png
// module id = Zj0p
// module chunks = 2